/**
 * Owner Portal — DAC7 magic link.
 * Wraps the send-setup-link + status endpoints exposed by
 * backend/pms/owner_portal_views.py.
 */
import axios from 'axios'
import SETTINGS from '@/config/settings.js'

const base = `${SETTINGS.API.baseUrl}/api/pms/property-owners`

function authHeaders() {
  const token = localStorage.getItem('token')
  return token ? { Authorization: `Bearer ${token}` } : {}
}

const client = axios.create({ timeout: SETTINGS.API.timeout || 30000 })
client.interceptors.request.use((config) => {
  config.headers = { ...config.headers, ...authHeaders() }
  return config
})

export default {
  sendSetupLink(ownerId, email) {
    return client
      .post(`${base}/${ownerId}/send-setup-link/`, email ? { email } : {})
      .then((r) => r.data)
  },
  linkStatus(ownerId) {
    return client
      .get(`${base}/${ownerId}/setup-link-status/`)
      .then((r) => r.data)
  },
}
